import React, { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { LockKeyhole } from "lucide-react";

export default function AdminLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
      nav("/admin");
    } catch (err) {
      const msg = err.response?.data?.detail;
      toast.error(typeof msg === "string" ? msg : "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen bg-white flex items-center justify-center px-6">
      <div className="w-full max-w-md bg-white rounded-3xl border border-brand-line p-8 shadow-warm-lg">
        <div className="w-12 h-12 rounded-full bg-brand-ink grid place-items-center text-white"><LockKeyhole className="w-5 h-5" /></div>
        <h1 className="mt-6 font-display text-3xl text-brand-ink">Admin sign in</h1>
        <p className="mt-2 text-sm text-brand-stone">Cake World USA management console.</p>

        <form onSubmit={submit} className="mt-8 space-y-5" data-testid="admin-login-form">
          <div>
            <label className="text-xs font-semibold uppercase tracking-wide text-brand-ink">Email</label>
            <input
              type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              data-testid="admin-email"
              className="mt-1.5 w-full h-11 rounded-xl bg-white border border-brand-line px-3 text-sm focus:outline-none focus:ring-2 focus:ring-brand-red"
            />
          </div>
          <div>
            <label className="text-xs font-semibold uppercase tracking-wide text-brand-ink">Password</label>
            <input
              type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
              data-testid="admin-password"
              className="mt-1.5 w-full h-11 rounded-xl bg-white border border-brand-line px-3 text-sm focus:outline-none focus:ring-2 focus:ring-brand-red"
            />
          </div>
          <button
            type="submit" disabled={loading}
            data-testid="admin-login-submit"
            className="w-full h-12 rounded-full bg-brand-ink text-white text-sm font-semibold hover:bg-brand-ink disabled:opacity-50 transition"
          >
            {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
